// extracted by mini-css-extract-plugin
export var st0 = "derma-module--st0--2UGxM";
export var st1 = "derma-module--st1--2Ee_8";
export var st2 = "derma-module--st2--lGXQQ";
export var svgElem1 = "derma-module--svg-elem-1--3YE6_";
export var active = "derma-module--active--30qgR";
export var svgElem2 = "derma-module--svg-elem-2--2e11Y";
export var svgElem3 = "derma-module--svg-elem-3--2kYrm";
export var svgElem4 = "derma-module--svg-elem-4--2VQIg";
export var svgElem5 = "derma-module--svg-elem-5--IPpjN";